import React from 'react'

import gatsby from '../assets/images/gatsby.png'
import github from '../assets/images/github.png'
import netlify from '../assets/images/netlify.png'
import config from '../utils/config'

import { Love } from '../assets/Love'

const links = [
  { url: 'https://paypal.me/membasuh', label: 'PayPal' },
  { url: 'https://buymeacoffee.com/azisalvriyanto', label: 'Buy Me a Coffee' },
  { url: 'https://ko-fi.com/azisalvriyanto', label: 'Ko-fi' },
  { url: 'https://trakteer.id/azisalvriyanto/tip', label: 'Trakteer' },
  { url: 'https://saweria.co/azisalvriyanto', label: 'Saweria' },
]
const madeWithLinks = [
  { url: 'https://gatsbyjs.org', label: 'Gatsby', icon: gatsby },
  { url: 'https://github.com/fyvri', label: 'GitHub', icon: github },
  { url: 'https://netlify.com', label: 'Netlify', icon: netlify },
]

export const Footer = () => {
  return (
    <footer className="footer">
      <section className="footer-section">
        <nav className="footer-menu">
          {links.map((link) => (
            <a
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              key={link.url}
              className="footer-link"
            >
              {link.label}
            </a>
          ))}
        </nav>
        <nav className="footer-menu-buttons">
          {madeWithLinks.map((link) => (
            <a
              href={link.url}
              title={link.label}
              target="_blank"
              rel="noopener noreferrer"
              key={link.url}
              className="button small"
            >
              <img
                src={link.icon}
                alt={`${link.label} Logo`}
                aria-hidden="true"
                width="20"
                height="20"
              />
              <span>{link.label}</span>
            </a>
          ))}
        </nav>
        <div className="footer-made-by">
          Made with <Love /> by {config.author}
        </div>
      </section>
    </footer>
  )
}
